export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 课件标题
                coursewareTitle: '',
                // 课程编号
                courseNumber: '',
                // 课程名称
                courseName: '',
                // 课件类型
                coursewareType: '',
                // 课件简介
                coursewareInfo: '',
                // 外部视频id
                videoId: '',
                // 课件链接
                coursewareLink: '',
                // 视频时长
                videoTime: '',
                // 课程标签
                courseLable: '',
            },
            // 课程名称
            courseList: [
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '1',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '2',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '3',
                },
                {
                    label: '高铁用高性能混凝土的研究',
                    value: '4',
                },
            ],
            // 课件类型
            courseTypes: [
                {
                    label: '威视',
                    value: '威视',
                },
                {
                    label: '视频',
                    value: '视频',
                },
                {
                    label: '电子书',
                    value: '电子书',
                },
            ],
            // 课程标签
            courseLables: [
                {
                    label: '标签1',
                    value: '标签1',
                }
            ],
            // 表格数据
            tableData: [
                {
                    id: 1,
                    courseNumber: 'JXJY_C20147821',
                    courseName: '大学图书馆服务创新之探索与实践',
                    coursewareTitle: '大学图书馆服务创新之探',
                    coursewareType: '威视',
                    coursewareLabel: '',
                    videoId: '0949bbbdce846acd18b75eca6',
                    coursewareLink: 'ttp://player.polyv.net/videos/p',
                    imageLink: 'sssssss',
                    videoTime: '00:05:30',
                    coursewareInfo: '不错不错',
                    fileSize: '',
                    sort: 15,
                    md5: '',
                },
                {
                    id: 2,
                    courseNumber: 'JXJY_C20147821',
                    courseName: '大学图书馆服务创新之探索与实践',
                    coursewareTitle: '大学图书馆服务创新之探',
                    coursewareType: '威视',
                    coursewareLabel: '',
                    videoId: '0949bbbdce846acd18b75eca6',
                    coursewareLink: 'ttp://player.polyv.net/videos/p',
                    imageLink: 'sssssss',
                    videoTime: '00:05:30',
                    coursewareInfo: '不错不错',
                    fileSize: '',
                    sort: 15,
                    md5: '',
                },
                {
                    id: 3,
                    courseNumber: 'JXJY_C20147821',
                    courseName: '大学图书馆服务创新之探索与实践',
                    coursewareTitle: '大学图书馆服务创新之探',
                    coursewareType: '威视',
                    coursewareLabel: '',
                    videoId: '0949bbbdce846acd18b75eca6',
                    coursewareLink: 'ttp://player.polyv.net/videos/p',
                    imageLink: 'sssssss',
                    videoTime: '00:05:30',
                    coursewareInfo: '不错不错',
                    fileSize: '',
                    sort: 15,
                    md5: '',
                },
            ],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 导入课件对话框
            importCourseDialog: false,
            // 下载导入模板
            download: '',
            // 上传的试题导入地址
            address01: '',
            // 新增课件对话框
            addNewCoursewareDialog: false,
            // 新增课件表单数据
            addform: {
                // 课程编号
                courseNumber: '',
                // 课程名称
                courseName: '',
                // 课件标题
                coursewareTitle: '',
                // 课件类型
                coursewareType: '',
                // 课件简介
                coursewareInfo: '',
                // 外部视频id
                videoId: '',
                // 课件链接
                coursewareLink: '',
                // 视频时长
                videoTime: '',
                // 图片链接
                imageLink: '',
                // 文件尺寸
                fileSize: '',
                // 排序位置
                sort: '',
                // 课程标签
                courseLable: '',
                md5: '',
            },
            // 修改课件对话框
            editCoursewareDialog: false,
            // 修改课件表单数据
            editform: {
                // 课程编号
                courseNumber: '',
                // 课程名称
                courseName: '',
                // 课件标题
                coursewareTitle: '',
                // 课件类型
                coursewareType: '',
                // 课件简介
                coursewareInfo: '',
                // 外部视频id
                videoId: '',
                // 课件链接
                coursewareLink: '',
                // 视频时长
                videoTime: '',
                // 图片链接
                imageLink: '',
                // 文件尺寸
                fileSize: '',
                // 排序位置
                sort: '',
                // 课程标签
                courseLable: '',
                md5: '',
            },
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        // 搜索
        search() {

        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 批量导入课件
        httpreq01(q) {
            this.$upload(this.address01, q).then(res => {
                this.$message({
                    message: '导入课件完成',
                    type: 'success'
                });
            });
        },

        // 点击新增课件按钮
        handleNewCourseware() {
            this.addNewCoursewareDialog = true;
        },

        // 确定新增课件
        addNewCourseware() {
            this.$message.success('新增成功！');
            this.addNewCoursewareDialog = false;
        },

        // 点击修改课件按钮
        handleEditCourseware() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            this.editCoursewareDialog = true;

            // 发送请求获取数据
            this.editform = {
                id: 1,
                courseNumber: 'JXJY_C20147821',
                courseName: '大学图书馆服务创新之探索与实践',
                coursewareTitle: '大学图书馆服务创新之探',
                coursewareType: '威视',
                coursewareLabel: '',
                videoId: '0949bbbdce846acd18b75eca6',
                coursewareLink: 'ttp://player.polyv.net/videos/p',
                imageLink: 'sssssss',
                videoTime: '00:05:30',
                coursewareInfo: '不错不错',
                fileSize: '',
                sort: 15,
                md5: '',
            };
        },

        // 确定修改课件
        editCourseware() {
            this.$message.success('修改成功！');
            this.editCoursewareDialog = false;
        },

        // 删除课件
        handleDeleteCourseware() {
            // 先判断是否有选择记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            this.$message.success('删除成功！');
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },
    }
}